import { ChangeEvent } from 'react';
import { Checkbox } from '@nimbus-ds/components';
import { useTranslationAccount } from 'domains/Account/hooks';
import TaxRateInput from '../TaxRateInput';

interface GeneralTaxProps {
  checked: boolean;
  onCheckChange: (checked: boolean) => void;
  taxRate: number;
  onChange: (taxRate: number) => void;
}

function GeneralTax({
  checked,
  onCheckChange,
  taxRate,
  onChange,
}: GeneralTaxProps) {
  const t = useTranslationAccount('businessDataPage.generalInformationCard');
  const handleChangeTaxRate = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(Number(e.target.value));
  };

  return (
    <>
      <Checkbox
        label={t('orderTaxesEnabled.label')}
        name="orderTaxesExceptions"
        checked={checked}
        onChange={(event) => onCheckChange(event.target.checked)}
      />
      {checked && (
        <TaxRateInput
          value={taxRate}
          name="taxRateGeneral"
          onChange={handleChangeTaxRate}
        />
      )}
    </>
  );
}

export default GeneralTax;
